/*!
 * @monogrid/vue-boost v8.0.1 Copyright (C) MONOGRID S.R.L. - All Rights Reserved - Unauthorized copying of this file, via any medium is strictly prohibited
 */
import t from "@monogrid/vue-boost/core/LazyImage.vue";
import { defineComponent as d, shallowRef as i, computed as l } from "vue";
const g = d({
  name: "StaticImage",
  components: { LazyImage: t },
  props: {
    data: { type: Object, required: !0 },
    /**
     * It defines if the lazy image should be skipped. If a string is passed, it should contain the extension of the files to disable the feature for.
     */
    disableLazy: { type: [Boolean, String], default: "png" }
  },
  emits: ["loaded"],
  setup(a) {
    return {
      lazyImage: i(),
      lazySrc: l(() => {
        var e;
        if (!(!((e = a.data) != null && e.color) || (typeof a.disableLazy == "boolean" ? a.disableLazy : a.data.ext === a.disableLazy)))
          return `data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%20${a.data.width}%20${a.data.height}%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%22${a.data.width}%22%20height%3D%22${a.data.height}%22%20fill%3D%22${encodeURIComponent(a.data.color)}%22%20%2F%3E%3C%2Fsvg%3E`;
      })
    };
  }
});
export {
  g as default
};
